import { TableInfo } from '@Components/ViewWork/Table'
import clsx from 'clsx'
import Header from '@Components/ViewWork/Table/TableHeader'
import React from 'react'

const SubTable = ({ headerRow, rows }: TableInfo) => (
    <div className={clsx('table', 'sub-table')}>
        {headerRow && <Header row={headerRow.row} />}
        {rows.map(({ cells }, index) => (
            <div className="table-body table-row" key={`sub-row-${index}`}>
                {cells.map((cell, idx) => (
                    <div className="table-cell" key={`sub-row-cell-${idx}`}>
                        {cell}
                    </div>
                ))}
            </div>
        ))}
    </div>
)

export default SubTable
